module.exports = __webpack_public_path__ + "assets/images/frame-bl.206774e65f8410861b595094dc8e9143.png";